/**
 * @file Configuration overrides for the client.
 */

/** @type {import('@verosource/myhealth-web/src/config/networkConfig').NetworkConfig} */

const backendBaseUrl =
  'https://uat.myhealth.gnb-doh.vsfcloud.com/myhealth-gateway';

const networkConfig = {
  keycloakExternalIDP: 'simeio-uat',
  keycloakBaseUrl: 'https://iam.uat.myhealth.gnb-doh.vsfcloud.com/auth/',
  patientDataUrl: `${backendBaseUrl}/v3/patient/`,
  dependentDataUrl: `${backendBaseUrl}/v3/delegatedAccess/dependents/`,
  patientSummaryUrl: `${backendBaseUrl}/v1/patient-summary/`,
  patientSummaryManifestUrl: `${backendBaseUrl}/v1/patient-summary/manifest/`,
  patientSummaryViewerUrl:
    'https://myhealth-ps-viewer.uat.myhealth.gnb-doh.vsfcloud.com/',
  patientSummaryRevokeUrl: `${backendBaseUrl}/v1/patient-summary/manifest/revoke-access`,
  refreshTokenUrl: `${backendBaseUrl}/v3/authentication/refresh/`,
  medicationUrl: `${backendBaseUrl}/v3/medication/`,
  messagingUrl: `${backendBaseUrl}/v1/messaging/`,
  immunizationUrl: `${backendBaseUrl}/v3/immunization/`,
  observationUrl: `${backendBaseUrl}/v3/diagnosticReport/`,
  imagingUrl: `${backendBaseUrl}/v3/diagnosticImagingReport/`,
  diagnosticReportUrl:
    'https://uat.myhealth.gnb-doh.vsfcloud.com/myhealth-gateway/v1/diagnosticReport/',
  encounterUrl: `${backendBaseUrl}/v3/encounter/`,
  alertUrl:
    'https://uat.myhealth.gnb-doh.vsfcloud.com/myhealth-gateway/v1/alert/',
  redirectUri: 'https://myhealth-web.uat.myhealth.gnb-doh.vsfcloud.com/',
  loginUrl: `${backendBaseUrl}/v1/authentication/login`,
  authorizeUrl: 'https://uat.id.gnb.ca/as/authorization.oauth2',
  clientId: 'MHNBPHRCLIENT',
  loginProviderType: 'myhealth_broker_uat_new',
  salesforcePortal: 'https://myhealth-uat.gnb.ca/s/',
};

export default networkConfig;
